<template>
  <div class="animated fadeIn">
    <MainMenu></MainMenu>
    <Branding></Branding>

    <div class="grey lighten-5 mb-5">
      <v-row justify="center" class="ma-0 mt-5 pl-lg-10 pr-lg-10">
        <v-col md="10" lg="8" xl="6">
          <router-view></router-view>
        </v-col>
      </v-row>
    </div>

    <Footer></Footer>

    <ImgGallery></ImgGallery>
  </div>
</template>

<script>
  import Branding from "@/components/Branding";
  import ImgGallery from "@/components/ImgGallery";
  import MainMenu from "@/components/MainMenu";
  import Footer from "@/components/Footer";

  export default {
    name: "DefaultContainer",
    components: {
      Branding,
      ImgGallery,
      MainMenu,
      Footer
    }
  }
</script>

<style scoped>

</style>
